import HttpService from "./httpService";


// Types
export interface PaymentMethod {
    _id: string;
    entityId: number;
    name: string;
    enabled: boolean;
    type: string;
    config?: {
      keyId?: string;
      secretKey?: string;
      upiId?: string;
      merchantId?: string;
      apiKey?: string;
      clientId?: string;
      clientSecret?: string;
    };
  }

export class PaymentService {
    
    static getPaymentDetails = () => {
        return { url: 'www.test.com', totalAmount: 1 }
    }

    static getPaymentMethods = () => {
        return HttpService.get<any>('/payment-methods');
    }

    static enableDisablePaymentMethod = (paymentMethodId: string) => {
        return HttpService.patch('/payment-methods/enable-disable', { paymentMethodId });
    }

    static updateUpiId = (upiId: string) => {
        return HttpService.post(`/payment-methods/upi`, { upiId });
    }

    static updateRazorpayConfig = (keyId: string, secretKey: string) => {
        return HttpService.post(`/payment-methods/razorpay`, { keyId, secretKey });
    }

    static updatePhonePeConfig = (clientId: string, clientSecret: string) => {
        return HttpService.post(`/payment-methods/phonepe`, { clientId, clientSecret });
    }

    static updateCodConfig = (enabled: boolean) => {
        return HttpService.post(`/payment-methods/cod`, { enabled });
    }

    static updateManualUpiConfig = (upiId: string) => {
        return HttpService.post(`/payment-methods/manual-upi`, { upiId });
    }

}